import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import api from '../../services/api';
import './AnnouncementSection.css';

const AnnouncementSection = ({ section, layout = 'default' }) => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAnnouncements();
  }, []);

  const loadAnnouncements = async () => {
    try {
      const response = await api.get('/announcements/', {
        params: { display_type: 'section' }
      });
      setAnnouncements(response.data);
    } catch (error) {
      console.error('Error loading announcements:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="announcement-section homepage-section">
        <Container>
          <h2 className="section-title">{section.title}</h2>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  if (!announcements || announcements.length === 0) {
    return null;
  }

  const renderDefaultLayout = () => (
    <div className="announcements-stack">
      {announcements.map(announcement => (
        <Alert 
          key={announcement.id}
          className="announcement-alert announcement-default"
          style={{ backgroundColor: announcement.background_color || '#fff3cd' }}
        >
          <div className="d-flex align-items-start">
            {announcement.icon && (
              <i className={`${announcement.icon} announcement-icon me-3`}></i>
            )}
            <div className="flex-grow-1">
              <h5 className="alert-heading mb-2">{announcement.title}</h5>
              <div 
                className="announcement-text mb-2"
                dangerouslySetInnerHTML={{ __html: announcement.description }}
              />
              {announcement.link_url && (
                <a 
                  href={announcement.link_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-link p-0"
                >
                  {announcement.link_text || 'Learn More'}
                  <i className="fas fa-arrow-right ms-1"></i>
                </a>
              )}
            </div>
          </div>
        </Alert>
      ))}
    </div>
  );

  const renderCompactLayout = () => (
    <Row className="g-3">
      {announcements.map(announcement => (
        <Col key={announcement.id} lg={6} md={12} className="mb-3">
          <div 
            className="announcement-card"
            style={{ backgroundColor: announcement.background_color || '#fff3cd' }}
          >
            {announcement.icon && (
              <i className={`${announcement.icon} announcement-card-icon`}></i>
            )}
            <h6 className="announcement-card-title">{announcement.title}</h6>
            <div className="announcement-card-text">
              {announcement.description.replace(/<[^>]*>/g, '').substring(0, 100)}...
            </div>
            {announcement.link_url && (
              <a 
                href={announcement.link_url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-link"
              >
                View <i className="fas fa-arrow-right ms-1"></i>
              </a>
            )}
          </div>
        </Col>
      ))}
    </Row>
  );

  const renderContent = () => {
    switch(layout) {
      case 'compact':
        return renderCompactLayout();
      case 'default':
      default:
        return renderDefaultLayout();
    }
  };

  return (
    <section className={`announcement-section homepage-section announcement-layout-${layout}`}>
      <Container>
        <h2 className="section-title">{section.title}</h2>
        {renderContent()}
      </Container>
    </section>
  );
};

export default AnnouncementSection;
